import { BaseService } from 'core/services';
import TaskCommentRouteService from './TaskCommentRouteService';

class TaskCommentService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new TaskCommentRouteService());
    }

}

export default TaskCommentService;
